import { render, staticRenderFns } from "./SwitchModulePage.vue?vue&type=template&id=23cae186"
import script from "./SwitchModulePage.vue?vue&type=script&lang=js"
export * from "./SwitchModulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports